var _ = require('underscore');
var $ = require('jquery');
var Backbone = require("backbone");
var Dialog = require('DialogCustomRegions');
var Entities = require('Entities');
var Language = require('Language');
var Labels = EY.Consultation.Labels;
var Logger = require('Logger');
var Marionette = require('marionette');

var user = null;

var PrivacyPolicyHeader = Marionette.View.extend({
    template: '#PrivacyPolicyHeader'
});

var PrivacyPolicyBody = Marionette.View.extend({
    template: '#PrivacyPolicyBody'
});

var PrivacyPolicyFooter = Marionette.View.extend({
    template: '#PrivacyPolicyFooter',
    ui: {
        agreementCheckbox: '#agreementCheckbox',
        acknowledgeBtn: '#acknowledgeBtn'
    },
    events: {
        "click @ui.agreementCheckbox": "toggleView",
        "click @ui.acknowledgeBtn": "save"
    },
    toggleView: function (e) {
        if (e && e.target.checked) {
            this.ui.acknowledgeBtn.removeAttr("disabled").removeClass("disabled");
        } else {
            this.ui.acknowledgeBtn
                .attr("disabled", "disabled")
                .addClass("disabled")
                .blur();
        }
    },
    save: function () {
        user.save({
            privacyAck: true,
            privacyAckDate: new Date().toISOString(),
            privacyAckVersion: EY.Consultation.PrivacyPolicyVersion
        }).done(function (result) {
            var currentUser = EY.Consultation.CurrentUser;
            currentUser.model.set({
                'privacyAck': result.privacyAck,
                'privacyAckDate': result.privacyAckDate,
                'privacyAckVersion': result.privacyAckVersion
            });
            Logger.logToServer(JSON.stringify({
                user: EY.Consultation.CurrentUser.givenName,
                email: EY.Consultation.CurrentUser.upn,
                date: new Date().toLocaleString(),
                action: EY.Consultation.CurrentUser.givenName + ' has acknowledged the Privacy Notice ' + EY.Consultation.PrivacyPolicyVersion
            }), 'PrivacyPolicyAcknowledgement');
            Dialog.hide();
        }).fail(function (error) {
            Logger.log(`Error saving privacy acknowledgement: ${error.statusText} ${error.status}`);
        });
    }
});

var PrivacyPolicyFooterStatic = Marionette.View.extend({
    template: '#PrivacyPolicyFooterStatic',
    ui: {
        closeBtn: '#closeBtn'
    },
    events: {
        "click @ui.closeBtn": "close"
    },
    close: function () {
        Dialog.hide();
    }
});

module.exports.start = function () {
    const id =
        EY &&
        EY.Consultation &&
        EY.Consultation.CurrentUser &&
        EY.Consultation.CurrentUser.upn;
    user = new Entities.User({id: id});
    $('html,body').addClass('wait-cursor');
    user.fetch().done(function (userDetails) {
        $('html,body').removeClass('wait-cursor');
        if (!_.isEmpty(userDetails) && (!userDetails.privacyAck || userDetails.privacyAckVersion !== EY.Consultation.PrivacyPolicyVersion)) {
            Dialog.show({
                headerView: new PrivacyPolicyHeader({
                    model: new Backbone.Model({title: Labels.PrivacyNotice_Heading})
                }),
                bodyView: new PrivacyPolicyBody({
                    model: new Backbone.Model()
                }),
                footerView: new PrivacyPolicyFooter(),
                modalClass: 'privacy-policy-modal',
                size: "modal-xl"
            });
        } else {
            Dialog.show({
                headerView: new PrivacyPolicyHeader({
                    model: new Backbone.Model({title: Labels.PrivacyNotice_Heading})
                }),
                bodyView: new PrivacyPolicyBody({
                    model: new Backbone.Model()
                }),
                footerView: new PrivacyPolicyFooterStatic(),
                modalClass: 'privacy-policy-modal',
                size: "modal-xl"
            });
        }
    }).fail(function (error) {
        Logger.log(`Error fetching user details: ${error.statusText} ${error.status}`);
        $('html,body').removeClass('wait-cursor');
    });
};



// WEBPACK FOOTER //
// ./js/Modules/Privacy/PrivacyPolicy.js